import * as accounts from "./accounts";
import * as portal from "./portal";
import * as portalDiscovery from "./portalDiscovery";
import * as trustCenters from "./trustCenters";
import * as auth from "./auth";
import * as mediaAssets from "./mediaAssets";

const externalApi = {accounts, portal, portalDiscovery, trustCenters, auth, mediaAssets};

export default externalApi;
